export function initCopyShortcodeHandler() {
  // Handle click on the Copy button
  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('.smart-content-sync-copy-shortcode-button');
    if (!btn) return;

    const shortcode = btn.getAttribute('data-shortcode');
    if (!shortcode) return;

    await tryCopyToClipboard(shortcode, btn);
  });

  // Handle double-click on the <code> block
  document.body.addEventListener('dblclick', async (e) => {
    const codeBlock = e.target.closest('.smart-content-sync-copy-shortcode');
    if (!codeBlock) return;

    const shortcode = codeBlock.getAttribute('data-shortcode');
    if (!shortcode) return;

    // Select the full text inside the <code> block
    selectText(codeBlock);

    // Copy to clipboard and update the adjacent button
    const btn = codeBlock.parentElement.querySelector('.smart-content-sync-copy-shortcode-button');
    await tryCopyToClipboard(shortcode, btn);
  });
}

function selectText(el) {
  const range = document.createRange();
  range.selectNodeContents(el);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
}

async function tryCopyToClipboard(shortcode, buttonEl) {
  if (!navigator.clipboard || !document.hasFocus()) {
    alert('Please focus the tab before copying.');
    return;
  }

  try {
    await navigator.clipboard.writeText(shortcode);

    if (buttonEl) {
      const original = buttonEl.textContent;
      buttonEl.textContent = 'Copied!';
      setTimeout(() => {
        buttonEl.textContent = original;
      }, 1500);
    }
  } catch (err) {
    console.error('Clipboard copy failed:', err);
    alert('Failed to copy to clipboard.');
  }
}
